import { round2, sumMoney } from './money.js';

/** Standard dansk momssats. Snapshottes paa fakturalinjen ved fakturering. */
export const DEFAULT_VAT_RATE = 25;

/** Tekst der skal staa paa fakturalinjer ved reverse charge. Engelsk - den er kundevendt til udlandet. */
export const REVERSE_CHARGE_TEXT = 'Reverse charge — customer accounts for VAT';

export interface VatResult {
  vatRate: number;
  vatAmount: number;
  amountInclVat: number;
  reverseCharge: boolean;
}

/**
 * Moms ud fra kundens landekode.
 *
 * Ikke-danske kunder faar reverse charge: momsen beregnes ikke, og fakturalinjerne
 * paafoeres REVERSE_CHARGE_TEXT. PRD §12.3.
 */
export function calculateVat(
  amountExclVat: number,
  options: { countryCode?: string; vatRate?: number } = {},
): VatResult {
  const countryCode = (options.countryCode ?? 'DK').toUpperCase();
  const reverseCharge = countryCode !== 'DK';
  const vatRate = reverseCharge ? 0 : (options.vatRate ?? DEFAULT_VAT_RATE);
  const vatAmount = round2(round2(amountExclVat) * (vatRate / 100));

  return {
    vatRate,
    vatAmount,
    amountInclVat: sumMoney([amountExclVat, vatAmount]),
    reverseCharge,
  };
}
